import type { IconData } from '@stacksjs/iconify-core'

export const newFolderSolid: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M19.742 5.193c-1.563-1.825-3.899-2.865-6.336-2.67c-3.136.251-5.378.592-6.935.909c-2.486.505-4.136 2.515-4.39 4.951c-.279 2.67-.581 7.413-.581 15.442s.302 12.772.58 15.442c.255 2.435 1.903 4.445 4.389 4.95C9.4 44.814 14.776 45.5 24 45.5s14.599-.686 17.531-1.283c2.486-.505 4.134-2.515 4.388-4.95c.279-2.67.581-7.413.581-15.442c0-3.147-.046-5.788-.12-7.997c-.137-4.148-3.556-7.307-7.617-7.307H23.82a2.68 2.68 0 0 1-2.036-.943z\"/>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default newFolderSolid
